import { generatePath, Link } from 'react-router-dom'
import { GridCellProps, GridColumnProps } from '@progress/kendo-react-grid'
import { AppropriatenessTestKey } from 'api/Clients/Types/AppropriatenessTestDto'
import { links } from 'utils/featureToggles'

export interface GridColumn extends GridColumnProps {
  show: boolean
  width?: number
}

export const appropriatenessTestColumns: GridColumn[] = [
  {
    title: 'Tickmill Company',
    field: AppropriatenessTestKey.tickmillCompany,
    show: true,
    filter: 'boolean',
  },
  {
    title: 'Test Set Category',
    field: AppropriatenessTestKey.category,
    show: true,
    filterable: true,
    filter: 'text',
  },
  {
    title: 'Product',
    field: AppropriatenessTestKey.tickmillProduct,
    show: true,
    filterable: true,
    filter: 'text',
  },
  {
    title: 'Test Type',
    field: AppropriatenessTestKey.testType,
    show: true,
    cell: (props: GridCellProps): JSX.Element => {
      if (!props.dataItem?.id) {
        return <td />
      }

      return (
        <td style={{ color: 'blue', textDecoration: 'underline' }}>
          <Link
            to={{
              pathname: generatePath(links.complianceAppropriatenessTests.detailsUrl as string, {
                id: props.dataItem.id,
              }),
            }}
          >
            {props.dataItem.name}
          </Link>
        </td>
      )
    },
    filterable: true,
    filter: 'text',
  },
  {
    title: 'Affects Test Result',
    field: AppropriatenessTestKey.affectsTestResults,
    show: true,
    filterable: true,
    filter: 'text',
  },
  {
    title: 'Score settings',
    show: true,
    filterable: false,
    filter: 'text',
  },
]

export const scoreSettingsColumns: GridColumn[] = [
  {
    title: 'Test Set Category',
    field: AppropriatenessTestKey.category,
    show: true,
    filter: 'text',
  },
  {
    title: 'Product',
    field: AppropriatenessTestKey.tickmillProduct,
    show: true,
    filter: 'text',
  },
  {
    title: 'Marginally Pass',
    field: 'marginallyPass',
    show: true,
  },
  {
    title: 'Pass',
    field: 'pass',
    show: true,
  },
  {
    title: 'Fail',
    field: 'fail',
    show: true,
  },
]
